import { MenuItemProps, useTranslationLang, useTranslations } from "@bsm/component"
import { useMemo } from "react"

export const useGroupDetailsMenuTabs = (id: number) => {
    
    const [
        INFORMATIONS,
        EMPLOYEES,
        CALENDAR
    ] = useTranslations(i18n)
    
    const {lang} = useTranslationLang()

    return useMemo(
        (): Array<MenuItemProps> => [
            {
                ke: "about",
                label: INFORMATIONS,
                link: `about`,
            },
            {
                ke: "employees",
                label: EMPLOYEES,
                link: `employees`,
            },
            {
                ke: "calendar",
                label: CALENDAR,
                link: `calendar`,
            },
        ],
        [lang]
    );
}

const i18n = [
    'std_about',
    'std_employees',
    'std_calendar'
]
